// new menu list 
import { Divider, Typography, Card, CardContent, Grid, IconButton, Button, useTheme, Box,Badge, } from "@mui/material";

// icons
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';

import ScaleIcon from '@mui/icons-material/Scale';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import Crop169Icon from '@mui/icons-material/Crop169';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import PrintIcon from '@mui/icons-material/Print';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RecyclingIcon from '@mui/icons-material/Recycling';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { useTranslation } from "react-i18next";
import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../components/user-permission/UserPermission";
import { tokens } from "../../theme/theme";

const ProductManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, } = useTranslation();
    const userPermissions = useUserPermissions();


      const DashboardCard = ({ title, icon, onClick, badge, subtitle }) => (
        <Card
            elevation={3}
            sx={{
                backgroundColor: colors.primary[400],
                borderRadius: 3,
                p: 3,
                textAlign: "center",
                transition: "0.3s",
                "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: theme.shadows[6],
                },
            }}
        >
            <Box
                sx={{
                    width: 60,
                    height: 60,
                    mx: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: colors.primary[400],
                    borderRadius: "50%",
                    mb: 2,
                }}
            >
                {badge ? (
                    <Badge
                        badgeContent={badge}
                        color="error"
                        overlap="circular"
                        sx={{
                            "& .MuiBadge-badge": {
                                fontSize: "10px",
                                height: "16px",
                                minWidth: "16px",
                                padding: "0 4px",
                            },
                        }}
                    >
                        {icon}
                    </Badge>
                ) : (
                    icon
                )}
            </Box>

            <Typography variant="h6" fontWeight={600}>
                {title}
            </Typography>

            <Button
                variant="contained"
                color="secondary"
                sx={{ mt: 2 }}
                onClick={onClick}
            >
                {subtitle}
            </Button>
        </Card>
    );


    return (
        <Box >

            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">{t('prod_menu.productionmanagement')} </Typography>
                    </Box>
                </CardContent>
            </Card>

            {/* scan bar code */}
            {/* <Divider /> */}
            <Box mt={.5} display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" justifyContent="space-between" alignItems="center">

                </Box>

                <Box display="flex"
                    mr={1}
                    gridColumn={{
                        xs: 'span 2',
                        sm: 'span 3',
                        md: 'span 3',
                        lg: 'span 2',
                        xl: 'span 2',
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderStyle: 'dashed', // Set border style to dashed
                            }
                        }
                    }}
                >

                    <IconButton aria-label="stock-upload" onClick={() => SetActive("ViewDocumentSequence")} style={{ borderRadius: '8px', marginRight: '10px' }}>
                        <SettingsSuggestIcon style={{ color: "#2e7d32" }} />
                        <Typography textTransform={'none'} variant="button" style={{ marginLeft: '10px' }}>{t('prod_menu.documentsequencesettings')} </Typography>
                    </IconButton>
                    <IconButton aria-label="stock-upload" onClick={() => SetActive("ViewQRCodeSettings")} style={{ borderRadius: '8px', marginRight: '10px' }}>
                        <QrCodeScannerIcon style={{ color: "#ba68c8" }} />
                        <Typography textTransform={'none'} variant="button" style={{ marginLeft: '10px' }}>{t('prod_menu.qrcodeconfiguration')}</Typography>
                    </IconButton>
                    <IconButton aria-label="stock-upload" onClick={() => SetActive("AIChat")} style={{ borderRadius: '8px', marginRight: '10px' }}>
                        <AutoAwesomeIcon style={{ color: "#18a69aff" }} />
                        <Typography textTransform={'none'} variant="button" style={{ marginLeft: '10px' }}>Ask PapyAI</Typography>
                    </IconButton>
                </Box>
            </Box>
            <Divider />

            {/* <Divider />p={1} */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start"   >
                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <ReceiptIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Bill Of Material Plan</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("billofmaterialplan")}>Get</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <ReceiptIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>BOM Master</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("billofmaterialmaster")}>Add</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <ReceiptIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Bill Of Material</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("billofmaterial")}>Get</Button>
                        </Card>
                    </Grid>  */}
                    {/* 
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <ReceiptIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Costing</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("costing")}>Get</Button>
                        </Card>
                    </Grid>  */}

                    {hasPermission(userPermissions, "Paper Machine Production", "Enabled") && (                       
                         <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('prod_menu.papermachineproduction')}
                                icon={<RadioButtonUncheckedIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewPaperMachineEntryPage")}
                                subtitle="Booking"
                            />
                        </Grid>
                    )}

                    {hasPermission(userPermissions, "Winder Machine Production", "Enabled") && (
                       <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                            <DashboardCard
                                title={t('prod_menu.windermachineproduction')}
                                icon={<WorkspacesOutlinedIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewWinderMachinePage")}
                                subtitle="Create"
                            />
                        </Grid>
                    )}
                    {hasPermission(userPermissions, "Reel Weightment", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('prod_menu.reelweightement')}
                                icon={<ScaleIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewReelWeightment")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}
                    {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Enabled") && (
                       <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                            <DashboardCard
                                title={t('prod_menu.cuttersheeterconvertion')}
                                icon={<ContentCutOutlinedIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewCutterProductionEntryPage")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}
                    {hasPermission(userPermissions, "Ream Punching", "Enabled") && (                       
                         <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('prod_menu.reampunching')}
                                icon={<ViewStreamIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewReamWeightment")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}
                    {hasPermission(userPermissions, "Bundle Punching", "Enabled") && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                            <DashboardCard
                                title={t('prod_menu.bundlepunching')}
                                icon={<CropSquareIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewBundleWeightment")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}
                    {hasPermission(userPermissions, "Ream Pallet", "Enabled") && (
                       <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('prod_menu.reampalletpunching')}
                                icon={<Crop169Icon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ViewReamPallet")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}
                    {hasPermission(userPermissions, "FG Report", "Enabled") && (                        
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                            <DashboardCard
                                title="FG Product"
                                icon={<WarehouseIcon fontSize="large" color="secondary" />}
                               
                                onClick={() => SetActive("StoreFGINProduct")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}

                    {/* {hasPermission(userPermissions, "FG Report", "Enabled") && (                        
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <DashboardCard
                                title={t('prod_menu.fggoodsinwarehouse')}
                                icon={<WarehouseIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("StoreFGINProductWarehouse")}
                                subtitle="Update"
                            />
                        </Grid>
                    )}

                    {hasPermission(userPermissions, "FG Report", "Enabled") && (
                       <Grid item xs={12} sm={6} md={4} lg={3}  xl={2}>
                            <DashboardCard
                                title={t('prod_menu.updatefglocation')}
                                icon={<SettingsBackupRestoreIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ReverseFGINProductWarehouse")}
                                subtitle="Update"
                            />
                        </Grid>
                    )} */}




                    {/* {hasPermission(userPermissions, "Print Product Code", "Enabled") && (
                       <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                            <DashboardCard
                                title={t('prod_menu.printqrcode')}
                                icon={<PrintIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("PrintQRCode")}
                                subtitle="Update"
                            />
                        </Grid>
                    )} */}

                    {hasPermission(userPermissions, "Production MIS Reports", "Enabled") && (                     
                         <Grid item xs={12} sm={6} md={4} lg={3}>
                            <DashboardCard
                                title={t('prod_menu.productionreports')}
                                icon={<SummarizeIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ProductionReports")}
                                subtitle="Download"
                            />
                        </Grid>
                    )}

                     {hasPermission(userPermissions, "Reel Transfer", "Enabled") && (     

                  <Grid item xs={12} sm={6} md={4} lg={3}>
                            <DashboardCard
                                title={t('prod_menu.reeltransfer')}
                                icon={<ChangeCircleIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("TransferReel")}
                                subtitle="Transfer"
                            />
                        </Grid>)}

                      <Grid item xs={12} sm={6} md={4} lg={3}>                        
                            <DashboardCard
                                title={t('prod_menu.trackingreport')}
                                icon={<ReceiptIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ProductionMasterReport")}
                                subtitle="View"
                            />
                        </Grid>

                         {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                            <DashboardCard
                                title="Repulp Qty Entry"
                                icon={<RecyclingIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("RepulpWasteListIndex")}
                                subtitle="View"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <DashboardCard
                                title="Repulp Qty Report"
                                icon={<RecyclingIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("RepulpEntryReport")}
                                subtitle="View"
                            />
                        </Grid> */}
                         <Grid item xs={12} sm={6} md={4} lg={3}>
                            <DashboardCard
                                title={t('prod_menu.productionsummary')}
                                icon={<RecyclingIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("ProductionSummary")}
                                subtitle="View"
                            />
                        </Grid>
                        
                     {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Inventory2OutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Repulp Qty Report</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("RepulpWasteListIndex")}>View</Button>
                        </Card>
                    </Grid> 

                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Inventory2OutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('prod_menu.windermachineproduction')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("WinderProcess1")}>Convert</Button>
                        </Card>
                    </Grid> */}
                    
                    {/* Repeat the Grid item for each production entry */}
                    {/* You can customize the style and content for each card */}

                </Grid>
            </Box>
        </Box>

    )
}
export default ProductManagementMenu;







// dark menu list 

// import {
//     Divider, Typography, Card, CardContent, Grid, IconButton, Button,
//     useTheme, Box, Paper
// } from "@mui/material";

// import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

// import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
// import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
// import CommitOutlinedIcon from '@mui/icons-material/CommitOutlined';
// import ScatterPlotOutlinedIcon from '@mui/icons-material/ScatterPlotOutlined';
// import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';

// import { useTranslation } from "react-i18next";
// import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
// import useUserPermissions from "../../components/user-permission/UserPermission";

// import { tokens } from "../../theme/theme";

// const DashboardCard = ({ icon, title, actionName, SetActive }) => {
//     return (
//         <Paper
//             elevation={3}
//             sx={{
//                 p: 3,
//                 textAlign: "center",
//                 borderRadius: "20px",
//                 transition: "0.25s",
//                 cursor: "pointer",
//                 background: "linear-gradient(145deg, #ffffff30, #00000010)",
//                 backdropFilter: "blur(6px)",
//                 "&:hover": {
//                     transform: "translateY(-5px)",
//                     boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
//                 },
//             }}
//             onClick={() => SetActive(actionName)}
//         >
//             <Box>{icon}</Box>
//             <Typography variant="h6" mt={1} fontWeight="bold">
//                 {title}
//             </Typography>
//             <Button
//                 variant="contained"
//                 color="secondary"
//                 size="small"
//                 sx={{ mt: 2, borderRadius: "10px" }}
//             >
//                 Open
//             </Button>
//         </Paper>
//     );
// };

// const ProductionDashboard = ({ SetActive }) => {
//     const theme = useTheme();
//     const colors = tokens(theme.palette.mode);
//     const { t } = useTranslation();
//     const userPermissions = useUserPermissions();

//     return (
//         <Box p={2}>
//             {/* HEADER */}
//             <Card
//                 sx={{
//                     background: "transparent",
//                     borderRadius: "10px",
//                     mb: 1,
//                     py: 1,
//                 }}
//             >
//                 <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
//                     <Typography variant="h4" fontWeight="bold" color={colors.grey[100]}>
//                         ⚙️ {t("prod_menu.productionmanagement")}
//                     </Typography>

//                     <Box display="flex" gap={2}>
//                         <IconButton onClick={() => SetActive("ViewDocumentSequence")}>
//                             <SettingsSuggestIcon sx={{ color: "#2e7d32" }} />
//                         </IconButton>

//                         <IconButton onClick={() => SetActive("ViewQRCodeSettings")}>
//                             <QrCodeScannerIcon sx={{ color: "#ba68c8" }} />
//                         </IconButton>
//                     </Box>
//                 </CardContent>
//             </Card>

//             <Divider sx={{ mb: 3 }} />

//             {/* MODULE GRID */}
//             <Grid container spacing={3}>
//                 {hasPermission(userPermissions, "Paper Machine Production", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<LooksOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t("prod_menu.papermachineproduction")}
//                             actionName="ViewPaperMachineEntryPage"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Winder Machine Production", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<CommitOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t("prod_menu.windermachineproduction")}
//                             actionName="ViewWinderMachinePage"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Reel Weightment", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<ScatterPlotOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t("prod_menu.reelweightement")}
//                             actionName="ViewReelWeightment"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<ContentCutOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t("prod_menu.cuttersheeterconvertion")}
//                             actionName="ViewCutterProductionEntryPage"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Ream Punching", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<ContentCutOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t("prod_menu.reampunching")}
//                             actionName="ViewReamWeightment"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Bundle Punching", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<ScatterPlotOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t("prod_menu.bundlepunching")}
//                             actionName="ViewBundleWeightment"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Ream Pallet", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<Inventory2OutlinedIcon sx={{ fontSize: 20 }} />}
//                             title="Ream Pallet Punching"
//                             actionName="ViewReamPallet"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "FG Report", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<Inventory2OutlinedIcon sx={{ fontSize: 20 }} />}
//                             title="FG Product Warehouse"
//                             actionName="StoreFGINProductWarehouse"
//                             SetActive={SetActive}
//                         />
//                     </Grid>
//                 )}

//                 {/* {hasPermission(userPermissions, "FG Report", "Enabled") && (
//                         <Grid item xs={12} sm={6} md={4} lg={3}>
//                             <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
//                                 <ScatterPlotOutlinedIcon fontSize="large" />
//                                 <Typography variant="h6" mt={2}>FG Product</Typography>
//                                 <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("StoreFGINProduct")}>Update</Button>
//                             </Card>
//                         </Grid>
//                     )} */}

               
//                 {hasPermission(userPermissions, "FG Report", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<ScatterPlotOutlinedIcon sx={{ fontSize: 20 }} />}
//                             title="Reverse FG Warehouse Location"
//                             actionName="ReverseFGINProductWarehouse"
//                             SetActive={SetActive}
//                         />                        
//                     </Grid>
//                 )}


//                 {hasPermission(userPermissions, "Print Product Code", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<Inventory2OutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t('prod_menu.printqrcode')}
//                             actionName="PrintQRCode"
//                             SetActive={SetActive}
//                         />                       
//                     </Grid>
//                 )}

//                 {hasPermission(userPermissions, "Production MIS Reports", "Enabled") && (
//                     <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                         <DashboardCard
//                             icon={<Inventory2OutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t('prod_menu.productionreports')}
//                             actionName="ProductionReports"
//                             SetActive={SetActive}
//                         />
                       
//                     </Grid>
//                 )}


//                 <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                      <DashboardCard
//                             icon={<Inventory2OutlinedIcon sx={{ fontSize: 20 }} />}
//                             title={t('prod_menu.reeltransfer')}
//                             actionName="TransferReel"
//                             SetActive={SetActive}
//                         />                    
//                 </Grid>



//                 <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
//                      <DashboardCard
//                             icon={<Inventory2OutlinedIcon sx={{ fontSize: 20 }} />}
//                             title="Production Track Report"
//                             actionName="ProductionMasterReport"
//                             SetActive={SetActive}
//                         />                   
//                 </Grid>

//             </Grid>
//         </Box>
//     );
// };

// export default ProductionDashboard;


// ProductionDashboardFull.jsx
// import React, { useState, useMemo } from "react";
// import PropTypes from "prop-types";
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   IconButton,
//   useTheme,
//   Paper,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   TextField,
//   InputAdornment,
//   Chip,
//   Collapse,
//   Badge,
//   Tooltip,
// } from "@mui/material";

// import MenuIcon from "@mui/icons-material/Menu";
// import SearchIcon from "@mui/icons-material/Search";
// import AddIcon from "@mui/icons-material/Add";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
// import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";

// import LooksOutlinedIcon from "@mui/icons-material/LooksOutlined";
// import CommitOutlinedIcon from "@mui/icons-material/CommitOutlined";
// import ScatterPlotOutlinedIcon from "@mui/icons-material/ScatterPlotOutlined";
// import ContentCutOutlinedIcon from "@mui/icons-material/ContentCutOutlined";
// import StorageIcon from "@mui/icons-material/Storage";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import WarningAmberIcon from "@mui/icons-material/WarningAmber";

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RcTooltip, ResponsiveContainer, BarChart, Bar, Legend } from "recharts";

// import { useTranslation } from "react-i18next";
// import { tokens } from "../../theme/theme";
// import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
// import useUserPermissions from "../../components/user-permission/UserPermission";

// /*
//   Dependencies:
//   - @mui/material
//   - @mui/icons-material
//   - recharts

//   Notes:
//   - Replace mockData & KPI calculation with real API calls.
//   - SetActive prop (function) will navigate to the requested page in your app.
// */

// const KPI_CARD_STYLE = {
//   borderRadius: 2,
//   p: 2,
//   minHeight: 110,
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "space-between",
// };

// const small = { fontSize: 12, opacity: 0.85 };

// const KPICard = ({ title, value, delta, icon, sx = {}, color }) => {

//      const theme = useTheme();
//     const colors = tokens(theme.palette.mode);
//   return (
//     // <Paper elevation={3} sx={{ ...KPI_CARD_STYLE, ...sx }}>
//      <Card
//             elevation={3}
//             sx={{
//                 backgroundColor: colors.primary[400],
//                 borderRadius: 3,
//                 p: 3,
//                 textAlign: "center",
//                 transition: "0.3s",
//                 "&:hover": {
//                     transform: "translateY(-5px)",
//                     boxShadow: theme.shadows[6],
//                 },
//             }}
//         >
//       <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//         <Box>
//           <Typography variant="subtitle2" sx={small}>
//             {title}
//           </Typography>
//           <Typography variant="h5" fontWeight="bold">
//             {value}
//           </Typography>
//         </Box>
//         <Box>
//           <Box sx={{ fontSize: 32 }}>{icon}</Box>
//         </Box>
//       </Box>

//       <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
//         <Typography variant="caption" sx={{ color: color ?? "text.secondary" }}>
//           {delta >= 0 ? `▲ ${delta}% vs yesterday` : `▼ ${Math.abs(delta)}% vs yesterday`}
//         </Typography>
//         <Button size="small" color="secondary" variant="text">
//           View
//         </Button>
//       </Box>
//       </Card>
//     // </Paper>
//   );
// };




// const MachineStatusCard = ({ machine }) => {
//   const statusColor = {
//     Running: "#2e7d32",
//     Idle: "#f57f17",
//     Breakdown: "#d32f2f",
//   }[machine.status];

//   return (
//     <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Box>
//           <Typography variant="subtitle2">{machine.name}</Typography>
//           <Typography variant="h6" fontWeight="bold">
//             {machine.currentJob || "—"}
//           </Typography>
//         </Box>
//         <Box textAlign="right">
//           <Chip label={machine.status} sx={{ backgroundColor: statusColor, color: "#fff" }} />
//           <Typography variant="caption" display="block" mt={0.5}>
//             Load: {machine.loadPercent}%
//           </Typography>
//         </Box>
//       </Box>
//     </Paper>
//   );
// };

// // Mock data (replace with real API)
// const MOCK_KPI = {
//   productionToday: 12450, // meters or kg whatever unit
//   wip: 560,
//   fgStock: 3420,
//   utilization: 82,
//   rejectionRate: 1.8,
//   deltas: { productionToday: 3.2, wip: -1.2, fgStock: 0.5, utilization: 0.8, rejectionRate: -0.1 },
// };

// const MOCK_MACHINES = [
//   { id: 1, name: "Paper Machine 1", status: "Running", loadPercent: 85, currentJob: "Order #2509" },
//   { id: 2, name: "Winder 2", status: "Idle", loadPercent: 12, currentJob: null },
//   { id: 3, name: "Cutter 1", status: "Breakdown", loadPercent: 0, currentJob: null, issue: "Roll jam" },
//   { id: 4, name: "Sheeter 1", status: "Running", loadPercent: 75, currentJob: "Order #2510" },
// ];

// const MOCK_DAILY_PROD = [
//   { day: "Mon", produced: 1800 },
//   { day: "Tue", produced: 2100 },
//   { day: "Wed", produced: 2300 },
//   { day: "Thu", produced: 2000 },
//   { day: "Fri", produced: 2500 },
//   { day: "Sat", produced: 1800 },
//   { day: "Sun", produced: 1450 },
// ];

// const MOCK_MONTHLY = [
//   { month: "Jan", output: 45000 },
//   { month: "Feb", output: 42000 },
//   { month: "Mar", output: 48000 },
//   { month: "Apr", output: 51000 },
//   { month: "May", output: 47000 },
//   { month: "Jun", output: 50000 },
// ];

// const MOCK_MACHINE_PROD = [
//   { machine: "Paper Machine 1", amount: 25000 },
//   { machine: "Winder 2", amount: 12000 },
//   { machine: "Cutter 1", amount: 6000 },
//   { machine: "Sheeter 1", amount: 9000 },
// ];

// const ProductionDashboard = ({ SetActive = () => {} }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const { t } = useTranslation?.() ?? { t: (s) => s }; // fallback if i18n not present
//   const userPermissions = useUserPermissions();

//   // local UI states
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [showAlerts, setShowAlerts] = useState(true);
//   const [query, setQuery] = useState("");
//   const [filterMachine, setFilterMachine] = useState("All");

//   // derived data (could be replaced by server-side filtered results)
//   const filteredMachines = useMemo(() => {
//     let m = MOCK_MACHINES;
//     if (filterMachine !== "All") {
//       m = m.filter((x) => x.name === filterMachine);
//     }
//     if (query) {
//       m = m.filter((x) => x.name.toLowerCase().includes(query.toLowerCase()));
//     }
//     return m;
//   }, [query, filterMachine]);

//   // Alerts (mock)
//   const alerts = [
//     { id: 1, level: "warning", text: "Cutter 1 - Breakdown detected", date: "2025-11-20" },
//     { id: 2, level: "info", text: "FG stock below reorder level (Item A)", date: "2025-11-19" },
//     { id: 3, level: "info", text: "Pending reel weightment updates: 12", date: "2025-11-21" },
//   ];

//   // quick modules (reuse your permission checks)
//   const modules = [
//     { perm: "Paper Machine Production", text: t("prod_menu.papermachineproduction"), action: () => SetActive("ViewPaperMachineEntryPage"), icon: <LooksOutlinedIcon fontSize="large" /> },
//     { perm: "Winder Machine Production", text: t("prod_menu.windermachineproduction"), action: () => SetActive("ViewWinderMachinePage"), icon: <CommitOutlinedIcon fontSize="large" /> },
//     { perm: "Reel Weightment", text: t("prod_menu.reelweightement"), action: () => SetActive("ViewReelWeightment"), icon: <ScatterPlotOutlinedIcon fontSize="large" /> },
//     { perm: "Cutter Sheeter Convertion", text: t("prod_menu.cuttersheeterconvertion"), action: () => SetActive("ViewCutterProductionEntryPage"), icon: <ContentCutOutlinedIcon fontSize="large" /> },
//   ];

//   return (
//     <Box sx={{ width: "100%", p: 2 }}>
//       {/* Top bar */}
//       <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
//         <Box display="flex" alignItems="center" gap={2}>
//           <IconButton onClick={() => setDrawerOpen(true)} size="large">
//             <MenuIcon />
//           </IconButton>
//           <Typography variant="h4" fontWeight="bold" color={colors.grey[100]}>
//             {t("prod_menu.productionmanagement")}
//           </Typography>
//           <Chip label="Operations" sx={{ ml: 1 }} />
//         </Box>

//         <Box display="flex" alignItems="center" gap={1}>
//           <TextField
//             size="small"
//             placeholder="Search machine, order, batch..."
//             value={query}
//             onChange={(e) => setQuery(e.target.value)}
//             sx={{ width: 340 }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <Tooltip title="Notifications">
//             <IconButton onClick={() => setShowAlerts((s) => !s)}>
//               <Badge badgeContent={alerts.length} color="error">
//                 <NotificationsIcon />
//               </Badge>
//             </IconButton>
//           </Tooltip>

//           <IconButton onClick={() => SetActive("ViewDocumentSequence")}>
//             <SettingsSuggestIcon sx={{ color: "#2e7d32" }} />
//           </IconButton>
//           <IconButton onClick={() => SetActive("ViewQRCodeSettings")}>
//             <QrCodeScannerIcon sx={{ color: "#ba68c8" }} />
//           </IconButton>
//         </Box>
//       </Box>

//       {/* MAIN LAYOUT: Sidebar + Content */}
//       <Box display="flex" gap={2}>
//         {/* Sidebar */}
//         <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
//           <Box sx={{ width: 260, p: 1 }}>
//             <Box display="flex" alignItems="center" justifyContent="space-between" p={1}>
//               <Typography variant="h6">Modules</Typography>
//               <IconButton onClick={() => setDrawerOpen(false)}>
//                 <MenuIcon />
//               </IconButton>
//             </Box>
//             <Divider />
//             <List>
//               {[
//                 "Dashboard",
//                 "Production Entries",
//                 "Winder",
//                 "Cutter",
//                 "Ream Punching",
//                 "Bundle Punching",
//                 "Warehouse",
//                 "Reports",
//               ].map((label) => (
//                 <ListItem button key={label} onClick={() => { SetActive(label); setDrawerOpen(false); }}>
//                   <ListItemIcon>
//                     {label === "Warehouse" ? <StorageIcon /> : <TrendingUpIcon />}
//                   </ListItemIcon>
//                   <ListItemText primary={label} />
//                 </ListItem>
//               ))}
//             </List>
//           </Box>
//         </Drawer>

//         {/* Content area */}
//         <Box flex={1}>
//           {/* KPI Row */}
//           <Grid container spacing={2} mb={2}>
//             <Grid item xs={12} md={3}>
//               <KPICard
//                 title="Production Today"
//                 value={`${MOCK_KPI.productionToday}`}
//                 delta={MOCK_KPI.deltas.productionToday}
//                 icon={<TrendingUpIcon />}
//                 color="#2e7d32"
//               />
//             </Grid>

//             <Grid item xs={12} md={2}>
//               <KPICard title="WIP" value={MOCK_KPI.wip} delta={MOCK_KPI.deltas.wip} icon={<StorageIcon />} />
//             </Grid>

//             <Grid item xs={12} md={2}>
//               <KPICard title="FG Stock" value={MOCK_KPI.fgStock} delta={MOCK_KPI.deltas.fgStock} icon={<StorageIcon />} />
//             </Grid>

//             <Grid item xs={12} md={2}>
//               <KPICard title="Utilization %" value={`${MOCK_KPI.utilization}%`} delta={MOCK_KPI.deltas.utilization} icon={<LooksOutlinedIcon />} />
//             </Grid>

//             <Grid item xs={12} md={3}>
//               <KPICard title="Rejection Rate" value={`${MOCK_KPI.rejectionRate}%`} delta={MOCK_KPI.deltas.rejectionRate} icon={<WarningAmberIcon />} />
//             </Grid>
//           </Grid>
//            {/* sx={{
//                 backgroundColor: colors.primary[400],
//                 borderRadius: 3,
//                 p: 3,
//                 textAlign: "center",
//                 transition: "0.3s",
//                 "&:hover": {
//                     transform: "translateY(-5px)",
//                     boxShadow: theme.shadows[6],
//                 },
//             }} */}

//           {/* Top quick actions + filters */}
//           <Grid container spacing={2} mb={2}>
//             <Grid item xs={12} md={8}>
//               <Box sx={{ p: 1, display: "flex", gap: 2, alignItems: "center", }}>
//                 {/* <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={() => SetActive("NewProductionEntry")}>
//                   + New Production Entry
//                 </Button> */}
//                 {/* <Button variant="outlined" color="secondary" onClick={() => SetActive("ViewReelWeightment")}>
//                   Reel Weightment
//                 </Button>
//                 <Button variant="outlined" color="secondary" onClick={() => SetActive("ViewCutterProductionEntryPage")}>
//                   Conversion Entry
//                 </Button> */}

               
//                 {/* <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>  variant="text"*/}
//                   {modules.map((m) => hasPermission(userPermissions, m.perm, "Enabled") ? (
//                     <Button key={m.perm}  sx={{backgroundColor:colors.primary[400]}} variant="contained" startIcon={m.icon} onClick={m.action}>
//                      <Typography>{m.text}</Typography> 
//                     </Button>
//                   ) : null)}
//                 {/* </Box> */}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               {/* <Paper sx={{ p: 2 }}>
//                 <Typography variant="subtitle1" fontWeight="bold">
//                   Filters
//                 </Typography>
//                 <Box mt={1} display="flex" gap={1}>
//                   <TextField
//                     select
//                     value={filterMachine}
//                     onChange={(e) => setFilterMachine(e.target.value)}
//                     SelectProps={{ native: true }}
//                     size="small"
//                     sx={{ width: 160 }}
//                   >
//                     <option value="All">All Machines</option>
//                     {MOCK_MACHINES.map((m) => (
//                       <option key={m.id} value={m.name}>
//                         {m.name}
//                       </option>
//                     ))}
//                   </TextField>

//                   <Button variant="contained" onClick={() => { }}>
//                     Apply
//                   </Button>
//                 </Box>
//               </Paper> */}
//             </Grid>
            
//           </Grid>

//           {/* Alerts */}
//           {/* <Collapse in={showAlerts}>
//             <Paper sx={{ p: 2, mb: 2 }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center">
//                 <Typography variant="h6">Alerts & Notifications</Typography>
//                 <Button size="small" onClick={() => setShowAlerts(false)}>
//                   Hide
//                 </Button>
//               </Box>
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" gap={2} flexWrap="wrap">
//                 {alerts.map((a) => (
//                   <Paper key={a.id} sx={{ p: 1, minWidth: 220 }}>
//                     <Typography variant="body2">{a.text}</Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {a.date}
//                     </Typography>
//                   </Paper>
//                 ))}
//               </Box>
//             </Paper>
//           </Collapse> */}

//           {/* Charts + Machine status */}
//           <Grid container spacing={2}>
//             {/* <Grid item xs={12} lg={7}>
//               <Paper sx={{ p: 2 }}>
//                 <Typography variant="h6" mb={1}>
//                   Production Trends (Daily)
//                 </Typography>
//                 <ResponsiveContainer width="100%" height={240}>
//                   <LineChart data={MOCK_DAILY_PROD}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="day" />
//                     <YAxis />
//                     <RcTooltip />
//                     <Line type="monotone" dataKey="produced" stroke="#8884d8" strokeWidth={2} />
//                   </LineChart>
//                 </ResponsiveContainer>

//                 <Divider sx={{ my: 2 }} />

//                 <Typography variant="subtitle2" mb={1}>
//                   Monthly Output Comparison
//                 </Typography>
//                 <ResponsiveContainer width="100%" height={160}>
//                   <BarChart data={MOCK_MONTHLY}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="month" />
//                     <YAxis />
//                     <RcTooltip />
//                     <Bar dataKey="output" fill="#82ca9d" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </Paper>
//             </Grid> */}

//             {/* <Grid item xs={12} lg={5}>
//               <Paper sx={{ p: 2 }}>
//                 <Typography variant="h6" mb={1}>
//                   Machines & Status
//                 </Typography>
//                 <Grid container spacing={1}>
//                   {filteredMachines.map((m) => (
//                     <Grid key={m.id} item xs={12} sm={6}>
//                       <MachineStatusCard machine={m} />
//                     </Grid>
//                   ))}
//                 </Grid>

//                 <Divider sx={{ my: 2 }} />

//                 <Typography variant="subtitle2">Machine-wise Production</Typography>
//                 <ResponsiveContainer width="100%" height={140}>
//                   <BarChart data={MOCK_MACHINE_PROD}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="machine" />
//                     <YAxis />
//                     <RcTooltip />
//                     <Bar dataKey="amount" fill="#8884d8" />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </Paper>
//             </Grid> */}
//           </Grid>

//           {/* Lower: Module cards & reports */}
//           {/* <Box mt={2}>
//             <Grid container spacing={2}>
//               {[
//                 { title: "Transfer Reel", action: () => SetActive("TransferReel") },
//                 { title: "Production Master Report", action: () => SetActive("ProductionMasterReport") },
//                 { title: "FG Product Warehouse", action: () => SetActive("StoreFGINProductWarehouse") },
//                 { title: "Reverse FG Warehouse", action: () => SetActive("ReverseFGINProductWarehouse") },
//                 { title: "Print QR Code", action: () => SetActive("PrintQRCode") },
//                 { title: "Production Reports", action: () => SetActive("ProductionReports") },
//               ].map((card) => (
//                 <Grid item xs={12} sm={6} md={4} lg={3} key={card.title}>
//                   <Paper
//                     elevation={2}
//                     sx={{
//                       p: 2,
//                       borderRadius: 2,
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "flex-start",
//                       gap: 1,
//                     }}
//                   >
//                     <Typography variant="subtitle2">{card.title}</Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Quick access
//                     </Typography>
//                     <Box mt={1} width="100%" display="flex" justifyContent="flex-end">
//                       <Button size="small" variant="contained" onClick={card.action}>
//                         Open
//                       </Button>
//                     </Box>
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box> */}


//         </Box>
//       </Box>
//     </Box>
//   );
// };

// ProductionDashboard.propTypes = {
//   SetActive: PropTypes.func,
// };

// export default ProductionDashboard;




// model 2

// import { Box, Grid, Card, CardContent, Typography, Button, IconButton, useTheme } from "@mui/material";
// import { tokens } from "../../theme/theme";
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
// import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
// import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
// import CommitOutlinedIcon from '@mui/icons-material/CommitOutlined';
// import ScatterPlotOutlinedIcon from '@mui/icons-material/ScatterPlotOutlined';
// import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
// import { useTranslation } from "react-i18next";
// import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
// import useUserPermissions from "../../components/user-permission/UserPermission";

// export default function ProductionDashboard({ SetActive }) {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const { t } = useTranslation();
//   const userPermissions = useUserPermissions();

//   const kpis = [
//     { label: "Production Today", value: 12450, trend: "+3.2% vs yesterday" },
//     { label: "WIP", value: 560, trend: "↓ 1.2% vs yesterday" },
//     { label: "FG Stock", value: 3420, trend: "+0.5% vs yesterday" },
//     { label: "Utilization %", value: "82%", trend: "+0.8% vs yesterday" },
//     { label: "Rejection Rate", value: "1.8%", trend: "↓ 0.1% vs yesterday" },
//   ];

//   const machineStatus = [
//     { name: "Paper Machine 1", status: "Running", color: "#4caf50", order: "#2509", load: "85%" },
//     { name: "Winder 2", status: "Idle", color: "#ff9800", order: "—", load: "12%" },
//     { name: "Cutter 1", status: "Breakdown", color: "#e53935", order: "—", load: "0%" },
//     { name: "Sheeter 1", status: "Running", color: "#4caf50", order: "#2510", load: "75%" },
//   ];

//   const modules = [
//     { perm: "Paper Machine Production", icon: <LooksOutlinedIcon fontSize="large" />, text: t('prod_menu.papermachineproduction'), action: () => SetActive("ViewPaperMachineEntryPage"), button: "Booking" },
//     { perm: "Winder Machine Production", icon: <CommitOutlinedIcon fontSize="large" />, text: t('prod_menu.windermachineproduction'), action: () => SetActive("ViewWinderMachinePage"), button: "Create" },
//     { perm: "Reel Weightment", icon: <ScatterPlotOutlinedIcon fontSize="large" />, text: t('prod_menu.reelweightement'), action: () => SetActive("ViewReelWeightment"), button: "Update" },
//     { perm: "Cutter Sheeter Convertion", icon: <ContentCutOutlinedIcon fontSize="large" />, text: t('prod_menu.cuttersheeterconvertion'), action: () => SetActive("ViewCutterProductionEntryPage"), button: "Convert" },
//     { perm: "Ream Punching", icon: <ContentCutOutlinedIcon fontSize="large" />, text: t('prod_menu.reampunching'), action: () => SetActive("ViewReamWeightment"), button: "Update" },
//     { perm: "Bundle Punching", icon: <ScatterPlotOutlinedIcon fontSize="large" />, text: t('prod_menu.bundlepunching'), action: () => SetActive("ViewBundleWeightment"), button: "Update" },
//     { perm: "Ream Pallet", icon: <ScatterPlotOutlinedIcon fontSize="large" />, text: "Ream Pallet Punching", action: () => SetActive("ViewReamPallet"), button: "Update" },
//     { perm: "FG Report", icon: <ScatterPlotOutlinedIcon fontSize="large" />, text: "FG Product Warehouse", action: () => SetActive("StoreFGINProductWarehouse"), button: "Update" },
//   ];

//   return (
//     <Box p={2} sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#121212' : '#f4f6f8', minHeight: '100vh' }}>

//       {/* Header */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//         <Typography variant="h4" fontWeight="bold" color={colors.grey[100]}>
//           {t('prod_menu.productionmanagement')}
//         </Typography>

//         <Box display="flex" gap={2}>
//           <IconButton onClick={() => SetActive("ViewDocumentSequence")}> <SettingsSuggestIcon sx={{ color: "#2e7d32" }} /> </IconButton>
//           <IconButton onClick={() => SetActive("ViewQRCodeSettings")}> <QrCodeScannerIcon sx={{ color: "#ba68c8" }} /> </IconButton>
//         </Box>
//       </Box>

//       {/* KPI Section */}
//       <Grid container spacing={2} mb={3}>
//         {kpis.map((k, i) => (
//           <Grid item xs={12} sm={6} md={4} lg={2.4} key={i}>
//             <Card sx={{
//               p: 2,
//               borderRadius: 3,
//               backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#ffffff',
//               border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid #e0e0e0'
//             }}>
//               <Typography variant="body2" color="gray">{k.label}</Typography>
//               <Typography variant="h5" mt={1}>{k.value}</Typography>
//               <Typography variant="caption" color="green">{k.trend}</Typography>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Machine Status */}
//       <Grid container spacing={2} mb={4}>
//         {machineStatus.map((m, i) => (
//           <Grid item xs={12} sm={6} md={3} key={i}>
//             <Card sx={{ p: 2, backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#ffffff' }}>
//               <Typography variant="h6">{m.name}</Typography>
//               <Typography variant="body2">Order: {m.order}</Typography>
//               <Box mt={1}>
//                 <Button size="small" sx={{ background: m.color, color: "#fff", borderRadius: 2 }}>{m.status}</Button>
//               </Box>
//               <Typography variant="caption">Load: {m.load}</Typography>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Modules Grid */}
//       <Grid container spacing={2}>
//         {modules.map((m, index) => hasPermission(userPermissions, m.perm, "Enabled") ? (
//           <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
//             <Card sx={{
//               backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : colors.primary[400],
//               backdropFilter: 'blur(6px)',
//               p: 2,
//               borderRadius: 3,
//               textAlign: 'center',
//               transition: '0.3s',
//               cursor: 'pointer',
//               border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid transparent',
//               '&:hover': { transform: 'translateY(-5px)', boxShadow: theme.palette.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.6)' : 6 }
//             }}>
//               <CardContent>
//                 {m.icon}
//                 <Typography variant="h6" mt={2}>{m.text}</Typography>
//                 <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={m.action}>{m.button}</Button>
//               </CardContent>
//             </Card>
//           </Grid>
//         ) : null)}
//       </Grid>
//     </Box>
//   );
// }